export const deliveryCodes = ["ATL", "SAR", "SIG", "ATL-PD", "SAR-PD", "SIG-PD"]
export const ausStates = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"]
export const exceptionTypeLabels = {
  NO_CARRIER_INELIGIBLE: "No Carrier Error",
  ON_HOLD: "On Hold",
  OVER_ORDERED: "Over Ordered",
  ADDR_VALIDATION_ERROR: "Address Validation Error",
}
